import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Network, RefreshCw } from "lucide-react";

import { AdminAPI } from "@/lib/admin-api";
import { Card, CardBody, CardHeader, CardTitle } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { Skeleton } from "@/components/ui/Skeleton";
import { EmptyState } from "@/components/ui/EmptyState";
import { TreeVisualization } from "./components/TreeVisualization";

export function TreeExplorerPage() {
  const nav = useNavigate();
  const { data, isLoading, refetch, isFetching } = useQuery({
    queryKey: ["admin-tree"],
    queryFn: AdminAPI.treeSnapshot,
  });

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-surface-900">Tree Explorer</h1>
          <p className="text-sm text-surface-500 mt-1">
            Immutable placement tree. Click any node to inspect the underlying Club Entry.
          </p>
        </div>
        <Button variant="outline" leftIcon={<RefreshCw className={isFetching ? "h-4 w-4 animate-spin" : "h-4 w-4"} />}
                onClick={() => refetch()}>
          Refresh
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Tree snapshot</CardTitle>
          <div className="text-xs text-surface-500">{data?.length ?? 0} nodes</div>
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <Skeleton className="h-96 w-full" />
          ) : data && data.length ? (
            <TreeVisualization
              nodes={data}
              onSelect={(id) => nav(`/admin/entries/${id}`)}
            />
          ) : (
            <EmptyState icon={Network} title="Tree is empty"
                        description="The first placed Club Entry will become the root node." />
          )}
        </CardBody>
      </Card>
    </div>
  );
}
